module.exports = __webpack_public_path__ + "img/icon-06.760d9cc0.svg";